import { takeLatest, put, call } from 'redux-saga/effects'
import * as actions from '../slices/index'

import Auth from '../../api/auth'
import constants from '../../constants'

export function* sendOTPSaga(action) {
  const { payload, resolve, reject } = action.payload
  try {
    const response = yield call(Auth.sendOtp, payload)
    if (Number(response?.code) === 1) {
      yield put(actions.sendOtpSuccess(response))
      resolve(response)
    } else {
      throw new Error(response?.message || 'Something went wrong')
    }
  } catch (error) {
    yield put(actions.sendOtpError(error))
    reject(error)
  }
}

export function* verifyOTPSaga(action) {
  const { payload, resolve, reject } = action.payload
  try {
    const response = yield call(Auth.verifyOtp, payload)
    if (Number(response?.code) === 1) {
      yield put(actions.verifyOtpSuccess(response))
      resolve(response)
    } else {
      throw new Error(response?.message || 'Something went wrong')
    }
  } catch (error) {
    yield put(actions.verifyOtpError(error))
    reject(error)
  }
}

export function* updateProfileSaga(action) {
  const { payload, resolve, reject } = action.payload
  try {
    const response = yield call(Auth.updateProfile, payload)
    if (Number(response?.code) === 1) {
      yield put(actions.updateProfileSuccess(response))
      resolve(response)
    } else {
      throw new Error(response?.message || 'Something went wrong')
    }
  } catch (error) {
    yield put(actions.updateProfileError(error))
    reject(error)
  }
}

export function* getPatientDetailsSaga(action) {
  const { payload, resolve, reject } = action.payload
  try {
    const response = yield call(Auth.getPatientDetails, payload)
    if (Number(response?.code) === 1) {
      yield put(actions.getPatientDetailsSuccess(response?.data))
      resolve(response?.data)
    } else {
      throw new Error(response?.message || 'Something went wrong')
    }
  } catch (error) {
    yield put(actions.getPatientDetailsError(error))
    reject(error)
  }
}

export function* registerPatientSaga(action) {
  const { payload, resolve, reject } = action.payload
  try {
    const response = yield call(Auth.registerPatient, payload)
    if (Number(response?.code) === 1) {
      yield put(actions.registerPatientSuccess(response))
      resolve(response)
    } else {
      throw new Error(response?.message || 'Something went wrong')
    }
  } catch (error) {
    yield put(actions.registerPatientError(error))
    reject(error)
  }
}

export function* updatePatientInformationSaga(action) {
  try {
    const response = yield call(Auth.updatePatientInformation, action.payload)
    if (response?.code == 1) {
      yield put(actions.updatePatientInformationSuccess(response?.data))
    } else {
      yield put(
        actions.updatePatientInformationError(
          response?.message || constants.ERROR_MSG,
        ),
      )
    }
  } catch (error) {
    yield put(
      actions.updatePatientInformationError(
        response?.message || constants.ERROR_MSG,
      ),
    )
  }
}

// Assign GLP Plan API call
export function* asignGLPPlanSaga(action) {
  try {
    const response = yield call(Auth.asignGLPPlan, action.payload)
    if (response?.code == 1) {
      yield put(actions.asignGLPPlanSuccess(response?.data))
    } else {
      yield put(
        actions.asignGLPPlanError(response?.message || constants.ERROR_MSG),
      )
    }
  } catch (error) {
    yield put(actions.asignGLPPlanError(error))
  }
}

export function* saveDoctorDetailsSaga(action) {
  try {
    const response = yield call(Auth.saveDoctorDetails, action.payload)
    if (response?.code == 1) {
      yield put(actions.saveDoctorDetailsSuccess(response?.data))
    } else {
      yield put(
        actions.saveDoctorDetailsError(
          response?.message || constants.ERROR_MSG,
        ),
      )
    }
  } catch (error) {
    yield put(actions.saveDoctorDetailsError(error || constants.ERROR_MSG))
  }
}

export function* authSaga() {
  yield takeLatest(actions.sendOtpRequest, sendOTPSaga)
  yield takeLatest(actions.verifyOtpRequest, verifyOTPSaga)
  yield takeLatest(actions.updateProfileRequest, updateProfileSaga)
  yield takeLatest(actions.getPatientDetailsRequest, getPatientDetailsSaga)
  yield takeLatest(actions.registerPatientRequest, registerPatientSaga)
  yield takeLatest(
    actions.updatePatientInformationRequest,
    updatePatientInformationSaga,
  )
  yield takeLatest(actions.asignGLPPlanRequest, asignGLPPlanSaga)
  yield takeLatest(actions.saveDoctorDetailsRequest, saveDoctorDetailsSaga)
}
